import { Globals } from "./Globals";
import { QPanel } from "./QPanel";
import { AddFramelessScrollbarH } from "../utils/AddFramelessScrollbarH";
import { AddFramelessScrollbar } from "../utils/AddFramelessScrollbar";
import { enumScrollBarType, kScrollBarThickness } from "../constants";

export class QBackgroundPanel extends QPanel {
  constructor() {
    super();
    this.fTabMgr = null;
    this.fDockContainerMgr = null;
    this.fFindRibbon = null;
    this.fMainRibbon = null;

    this.fPortPanel = null;

    this.fScrollBarH = null;
    this.fScrollBarV = null;
    this.fWSMgr = null;

    this.fZLayer = 0;
    this.fZPlanes = [];

    this.fRenderPhoenix = true;
  }

  InitBackgroundPanel(wsMgr) {
    this.fWSMgr = wsMgr;

    this.fUIColors = wsMgr.GetUIColors();

    this.ShowMainPanel(false);
    //  this.SetNeedsCustomResize(true);
  }

  ShowMainPanel(showPad) {
    this.SetFillColor(Globals._accountInfo.fUIColors[0]);
  }

  InitScrollBars(targetPanel) {
    if (this.fScrollBarH) {
      this.RemoveElement(this.fScrollBarV.fSlug);
      this.RemoveElement(this.fScrollBarH);
    }
    if (this.fScrollBarV) {
      this.RemoveElement(this.fScrollBarV.fSlug);
      this.RemoveElement(this.fScrollBarV);
    }

    AddFramelessScrollbarH(this, targetPanel);
    AddFramelessScrollbar(this, targetPanel, enumScrollBarType.vertical);
    var secondaryFill = this.fUIColors.GetSecondaryPanelFillColor();
    this.fScrollBarH.SetFillColor(secondaryFill);
    this.fScrollBarV.SetFillColor(secondaryFill);
    this.fScrollBarV.fStartY = this.GetHeight();
    //if (this.fDockContainerMgr)
    //	var tabWidth = this.fDockContainerMgr.GetShownContainerWidth();
    //else if (this.fWSMgr.fTabMgr)
    //	tabWidth = this.fWSMgr.fTabMgr.GetTabMgrEffectiveWidth(true);
    //else
    //	tabWidth = 0;
    this.fScrollBarH.fMaxX -= this.GetWidth();
    this.fPortPanel = targetPanel;
  }

  SetDockContainerMgr(dockContainerMgr) {
    this.fDockContainerMgr = dockContainerMgr;
  }

  SetFindRibbon(findRibbon) {
    this.fFindRibbon = findRibbon;
  }

  PrepRender(theWSMgr) {}

  AssembleCommand(theWSMgr) {}

  GetWidthNoBorder() {
    var w = this.fWidth;
    return w;
  }

  GetWidth() {
    var w = this.fWidth;
    //console.log('???')
    //if (this.fTabMgr)
    //{
    //    if (this.fTabMgr.IsTabMgrShown())
    //    {
    //        w = w - this.fTabMgr.GetTabMgrWidth(true); // - kWSPanelGap;
    //    }
    // }
    //else if (this.fDockContainerMgr)
    ///{
    //	w = w - this.fDockContainerMgr.GetShownContainerWidth();
    //}
    return w;
  }

  PostStandardResize() {
    var tabMgrOffset = 0;
    if (this.fScrollBarV) {
      this.fScrollBarV.fMaxY = this.fHeight + this.fScrollBarV.fStartY;
      this.fScrollBarV.fStartX = this.fWidth - tabMgrOffset - kScrollBarThickness;
      this.fScrollBarV.UpdateScrollBar();
    }
    if (this.fScrollBarH) {
      this.fScrollBarH.fStartX = 0; //TODO: left hand panels
      this.fScrollBarH.fMaxX = this.fWidth - tabMgrOffset;
      this.fScrollBarH.UpdateScrollBar();
    }
  }

  ObjectName() {
    return "QBackgroundPanel";
  }
}
